import { render } from "./addCompany.vue?vue&type=template&id=5c172b39&scoped=true"
import script from "./addCompany.vue?vue&type=script&lang=js"
export * from "./addCompany.vue?vue&type=script&lang=js"

import "./addCompany.vue?vue&type=style&index=0&id=5c172b39&lang=scss&scoped=true"

import exportComponent from "/root/qzf/src/kaipiao-admin-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c172b39"]])

export default __exports__